<div class="general-body">
    <!-- cards -->
    <div class="background-container">


        <div class="background-image" *ngIf="bankAccounts && bankAccounts.length > 0">
            <img src="../../../assets/img/Backkground.png" alt="Background Image" class="background-pic">
        </div>
        <div class="cards-container container">
            <div class="cards-dash row g-3">


                <!-- start card -->

                <div class="carousel-container" *ngIf="bankAccounts && bankAccounts.length > 0">
                    <svg class="carousel-prev" (click)="prevSlide()" width="52" height="53" viewBox="0 0 52 53">
                        <rect x="51.5" y="52.25" width="51" height="51" rx="25.5" transform="rotate(-180 51.5 52.25)"
                            fill="#F6F4F6" />
                        <rect x="51.5" y="52.25" width="51" height="51" rx="25.5" transform="rotate(-180 51.5 52.25)"
                            stroke="#532E60" />
                        <path
                            d="M28.5752 20.1496L23.1419 25.5829C22.5002 26.2246 22.5002 27.2746 23.1419 27.9163L28.5752 33.3496"
                            stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
                            stroke-linejoin="round" />
                      </svg>


                    <owl-carousel-o #carousel [options]="carouselOptions">
                        <ng-container *ngFor="let bAcc of bankAccounts">
                            <ng-template carouselSlide>
                                <div class="item">
                                    <!-- Bank Account Card -->
                                    <div class="card upper-cards shadow-lg position-relative" [ngClass]="{'selected-card': selectedBankAccount?.id === bAcc.id}" style="cursor: pointer;" (click)="selectBankAccount(bAcc.id)">
                                        <!-- Update Button -->
                                        <div class="update-button-wrapper" *ngIf="isBankAccountEditable(bAcc)">
                                            <button class="btn btn-update" (click)="updateSelectedBankAccount(bAcc.id); $event.stopPropagation()">Update</button>
                                        </div>

                                        <div class="card-body">
                                            <!-- Bank Account Header -->
                                            <div class="d-flex align-items-center">
                                                <div class="col-12">
                                                    <h5 class="card-title title-card fw-bold mb-1">
                                                        <i class="fas fa-university me-2"></i> {{ getBankDescription((bAcc.name === 'other' ? bAcc.otherBankName : bAcc.name) || '') }}
                                                    </h5>
                                                </div>
                                            </div>

                                            <!-- Bank Account Number -->
                                            <div class="card-details pt-3">
                                                <p class="card-text">
                                                    <i class="fas fa-hashtag me-2"></i> {{ bAcc.accountNumber }}
                                                </p>
                                            </div>

                                            <!-- Bank IBAN -->
                                            <div class="card-details-1 pt-2">
                                                <p class="card-text">
                                                    <i class="fas fa-barcode me-2"></i> {{ bAcc.bankIBAN }}
                                                </p>
                                            </div>

                                            <!-- Bank Account Status -->
                                            <div class="pt-4">
                                                <span *ngIf="bAcc.bankStatus == 1" class="badge bg-warning text-dark p-2 fw-bold">
                                                    <i class="fas fa-hourglass-half me-1"></i> Pending
                                                </span>
                                                <span *ngIf="bAcc.bankStatus == 2" class="badge bg-success text-white p-2 fw-bold">
                                                    <i class="fas fa-check-circle me-1"></i> Approved
                                                </span>
                                                <span *ngIf="bAcc.bankStatus == 3" class="badge bg-danger text-white p-2 fw-bold">
                                                    <i class="fas fa-times-circle me-1"></i> Cancelled
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ng-template>
                        </ng-container>
                    </owl-carousel-o>

                    <svg class="carousel-next" (click)="nextSlide()" xmlns="http://www.w3.org/2000/svg" width="52" height="53" viewBox="0 0 52 53">
                        <rect x="0" y="0" width="51" height="51" rx="25.5" fill="#F6F4F6" />
                        <rect x="0" y="0" width="51" height="51" rx="25.5" stroke="#532E60" />
                        <path d="M23.425 33.35L28.8583 27.917C29.5 27.2753 29.5 26.2253 28.8583 25.5836L23.425 20.1503"
                            stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </svg>
                </div>




                <!-- end card -->

                <button class="btn btn-add-bank" *ngIf="canManageBankAccounts" (click)="onAddNewBankAccount()">
                    <i class="fas fa-plus me-2"></i> Add bank
                </button>



                <!-- <div class="col-lg-4 col-md-6 col-12" *ngFor="let bAcc of bankAccounts">

                  <div class="card upper-cards" style="cursor: pointer;" (click)="selectBankAccount(bAcc.id)">
                    <div class="card-body">
                        <div class="pt-2">
                          <div class="col-12">
                              <h5 class="card-title title-card fw-bold">{{bAcc.bankName}} - {{bAcc.branchName}}</h5>
                          </div>
                        </div>
                        <div class="card-details pt-2">
                            <p class="card-text">{{bAcc.accountNumber}}</p>
                        </div>
                        <div class="card-details-1 pt-3">
                            <p class="card-text">{{bAcc.iban}}</p>
                        </div>
                        <div class="pt-3">
                          <span *ngIf="bAcc.status == 1" class="closed-label border p-1 fw-bold ">
                            Pending
                          </span>
                          <span *ngIf="bAcc.status == 2" class=" progress-title-3 border p-1 fw-bold">
                            Approved
                          </span>
                          <span *ngIf="bAcc.status == 3" class="cancelled-label border p-1 fw-bold">
                            Cancelled
                          </span>
                        </div>
                    </div>
                  </div>

              </div> -->

            </div>
        </div>

        <div class="mandatory-application m-4">
            <div class="inside-out p-4">
                <div class="container pt-4">

                    <form [formGroup]="bankAccountForm" *ngIf="bankAccountForm">
                        <div class="prime-address">
                            <div class="address-title">
                                <p class="fw-bold"><svg class="mark-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clip-path="url(#clip0_745_101254)">
                                            <path
                                                d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                                                stroke="#532E60" stroke-width="2" stroke-linecap="round"
                                                stroke-linejoin="round" />
                                            <path d="M12 16V12" stroke="#532E60" stroke-width="2" stroke-linecap="round"
                                                stroke-linejoin="round" />
                                            <path d="M12 8H12.01" stroke="#532E60" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round" />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_745_101254">
                                                <rect width="24" height="24" fill="white" />
                                            </clipPath>
                                        </defs>
                                    </svg> When Submitted, an account cannot be edited!</p>

                                <p *ngIf="showUpdateButton">
                                    <strong>You are currently updating the bank account with number <span
                                            style="color: #007bff;">{{ selectedBankAccount.accountNumber
                                            }}</span>.</strong>
                                </p>
                                <p *ngIf="showSubmitButton && !isBankAccountSelected">
                                    <strong>You are about to submit a new bank account.</strong>
                                </p>
                                <p *ngIf="!showUpdateButton && !showSubmitButton && isBankAccountSelected">
                                    <strong>You are viewing the details for bank account number <span
                                            style="color: #007bff;">{{ selectedBankAccount.accountNumber
                                            }}</span>.</strong>
                                </p>

                            </div>
                            <hr>
                            <div class="address-title">
                                <h4 class="fw-bold">Bank account</h4>
                            </div>
                            <div class="row">
                                <div class="col-12 col-md-6 pt-2">
                                    <div class="mb-3">
                                        <label for="bank-name-input" class="form-label fw-bold" appRequiredField="bankName">Bank name</label>
                                        <select class="city-input p-2 form-control rounded-4 bg-light" id="bankName" formControlName="bankName" (change)="onBankChange()">
                                            <option value="" selected disabled>Choose Bank</option>
                                            <option *ngFor="let bank of Banks" [value]="bank.bankId">
                                                {{ bank.description }}
                                            </option>
                                            <option value="other">Other (Please specify)</option>
                                        </select>
                                    </div>
                                </div>



                                <div class="col-12 col-md-6 pt-2">
                                    <div class="mb-3">
                                        <label for="bank-account-input" class="form-label fw-bold" appRequiredField="accountNumber">Bank account no</label>
                                        <input type="text" formControlName="accountNumber" class="city-input p-2 form-control rounded-4 bg-light" id="bank-account-input" placeholder="Enter your Bank Account">


                                    </div>
                                </div>

                                <!-- Conditionally show "Other Bank" input if "other" is selected -->
                                <div *ngIf="showOtherBank" class="col-12 col-md-6 pt-2">
                                    <div class="mb-3">
                                        <label for="other-bank-name-input" appRequiredField="otherBankName" class="form-label fw-bold">Specify Other Bank Name</label>
                                        <input type="text" class="city-input p-2 form-control rounded-4 bg-light" id="otherBankName" formControlName="otherBankName" placeholder="Enter Bank Name" />
                                    </div>
                                </div>

                            </div>

                            <div class="row">
                                <div class="col-12 col-md-6 pt-2">
                                    <div class="mb-3">
                                        <label for="iban-input" class="form-label fw-bold" appRequiredField="iban">IBAN</label>
                                        <input type="text" formControlName="iban" class="city-input p-2 form-control rounded-4 bg-light" id="iban-input" placeholder="Enter your IBAN" maxlength="34" (input)="onIbanInput($event)" />
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 pt-2">
                                    <div class="mb-3">
                                        <label for="swift-code-input" class="form-label fw-bold" appRequiredField="swiftCode">Swift code / BIC</label>
                                        <input type="text" formControlName="swiftCode" class="city-input p-2 form-control rounded-4 bg-light" id="swift-code-input" placeholder="Enter your Swift Code / BIC">
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12 col-md-6 pt-2">
                                    <div class="mb-3">
                                        <label for="branch-name-input" class="form-label fw-bold" appRequiredField="branchName">Branch name</label>
                                        <input type="text" formControlName="branchName" class="city-input p-2 form-control rounded-4 bg-light" id="branch-name-input" placeholder="Enter Branch Name">

                                    </div>
                                </div>
                                <div class="col-12 col-md-6 pt-2">
                                    <div class="mb-3">
                                        <label for="beneficiary-account-input" class="form-label fw-bold" appRequiredField="benficeryName">Beneficiary account name</label>
                                        <input type="text" formControlName="benficeryName" class="city-input p-2 form-control rounded-4 bg-light" id="beneficiary-account-input" placeholder="Enter Beneficiary Account" required>

                                    </div>
                                </div>
                            </div>

                            <!-- <div class="row">
                        <div class="col-12 col-md-6 pt-2">
                            <div class="mb-3">
                                <label for="active-from-input" class="form-label fw-bold">Active From <span
                                        class="text-danger">*</span></label>
                                <input type="text" placeholder="Active Form" class="form-control rounded-4 bg-light"
                                    id="active-from-input" required>
                            </div>
                        </div>
                    </div> -->
                        </div>


                        <div class="secondary-address">


                            <div class="postal-code-secondary row">

                                <div class="country-input-container col-12 col-md-6 pt-2">
                                    <div class="mb-3 country-section">
                                        <label for="country-input" class="country-label form-label fw-bold" appRequiredField="bankCountry">Country</label>

                                        <select class="country-input p-2 form-control rounded-4 bg-light" formControlName="bankCountry" id="country-input">
                                            <option value selected>Choose Country</option>
                                            <option *ngFor="let country of Countries" [value]="country.countryRegionId">
                                                {{ country.countryName }}
                                            </option>
                                        </select>
                                    </div>
                                </div>

                                <!-- <div class="postal-code-input-container-secondary col-12 col-md-6 pt-2">
                                    <div class="mb-3 postal-code-section-secondary">
                                        <label for="postal-code-input-secondary" class="cpostal-code-label-secondary form-label fw-bold" appRequiredField="BankCountry">Country Code</label>
                                        <input type="text" formControlName="BankCountry" class="postal-code-input-secondary p-2 form-control rounded-4 bg-light" id="postal-code-input-secondary" placeholder="Enter your Country Code">
                                    </div>
                                </div> -->


                                <div class="postal-code-input-container-secondary col-12 col-md-6 pt-2">
                                    <div class="mb-3 postal-code-section-secondary">
                                        <label for="Currency-code-input-secondary" class="cpostal-code-label-secondary form-label fw-bold" appRequiredField="currency">Currency</label>

                                        <select class="postal-code-input-secondary p-2 form-control rounded-4 bg-light" id="Currency" formControlName="currency" id="Currency-code-input-secondary" placeholder="Enter Account Currency">
                                            <option value="" selected disabled>Choose Currency</option>
                                            <option *ngFor="let Currencys of Currency" [value]="Currencys.currencyId">
                                                {{ Currencys.description }}
                                            </option>
                                        </select>


                                    </div>
                                </div>
                            </div>

                            <div class="city-field-secondary row">
                                <div class="city-input-container-secondary col-12 col-md-6 pt-2">
                                    <div class="mb-3 city-section-secondary">
                                        <label for="city-input-secondary" class="city-label-secondary form-label fw-bold" appRequiredField="email">Email for financial communication</label>
                                        <input type="text" formControlName="email" class="city-input-secondary p-2 form-control rounded-4 bg-light" id="email-input-secondary" placeholder="Email for Financial communication">

                                    </div>
                                </div>

                                <div class="country-field-secondary col-12 col-md-6 pt-2">
                                    <div class="mb-3 country-section-secondary">
                                        <label for="country-input-secondary" class="country-label-secondary form-label fw-bold" appRequiredField="address">Address</label>
                                        <textarea type="text" formControlName="address" class="city-input-secondary p-2 form-control rounded-4 bg-light" id="address-input-secondary" placeholder="Address">
                                        </textarea>
                                    </div>
                                </div>

                                <div class="country-field-secondary col-12 col-md-6 pt-2">
                                    <div class="mb-3 country-section-secondary">
                                        <label for="country-input-secondary" class="country-label-secondary form-label fw-bold" appRequiredField="ActiveDate">Active date</label>
                                        <input type="date" formControlName="ActiveDate" class="city-input-secondary p-2 form-control rounded-4 bg-light" id="ActiveDate" placeholder="ActiveDate">
                                    </div>
                                </div>

                                <div class="country-field-secondary col-12 col-md-6 pt-2">
                                    <div class="mb-3 country-section-secondary">
                                        <label for="country-input-secondary" class="country-label-secondary form-label fw-bold">Expiry date</label>
                                        <input type="date" formControlName="ExpiryDate" class="city-input-secondary p-2 form-control rounded-4 bg-light" id="ExpiryDate" placeholder="ExpiryDate">
                                    </div>
                                </div>

                            </div>

                            <div class="document-upload-field row">
                                <div class="document-upload-container col-12 col-md-6 pt-2">
                                    <div class="mb-3 document-upload-section">

                                        <div class="document-upload-field row">

                                            <app-file-upload #fileUpload label="Attach Company Bank Details on (COMPANY LETTER HEAD), signed by an Authorized Signatory as per the Establishment Card." inputId="Document" [placeholderText]="'Click or drag the file here to upload'" [multiple]="true" [isRequired]="true"
                                                [formControl]="documentFormControl" [disabled]="bankAccountForm.disabled" (fileUploaded)="onFileUpload($event, 'Document')" (fileRemoved)="handleFileRemove('Document', $event)" (allFilesUploaded)="onAllFilesUploaded()">
                                            </app-file-upload>






                                        </div>


                                    </div>
                                </div>

                                <div class="document-upload-container col-12 col-md-6 pt-2">
                                    <div class="mb-3 document-upload-section">

                                        <div class="document-upload-field row">

                                            <app-file-upload #bankCertificateUpload label="Bank Certificate" inputId="bankCertificate" [placeholderText]="'Click or drag the file here to upload'" [multiple]="true" [isRequired]="true"
                                                [formControl]="bankCertificateFormControl" [disabled]="bankAccountForm.disabled" (fileUploaded)="onFileUpload($event, 'bankCertificate')" (fileRemoved)="handleFileRemove('bankCertificate', $event)" (allFilesUploaded)="onBankCertificateFilesUploaded()">
                                            </app-file-upload>

                                        </div>


                                    </div>
                                </div>


                            </div>






                        </div>


                        <div class="container">
                            <div class="d-flex justify-content-end py-3 flex-wrap">
                                <div class="d-flex">
                                    <!-- Update Button -->
                                    <div *ngIf="canManageBankAccounts && showUpdateButton && !isBankAccountSelected" class="save-button mr-3">
                                        <a class="btn btn-save" (click)="onUpdateBankAccount()">Update</a>
                                    </div>
                                    <!-- Submit Button -->
                                    <div *ngIf="canManageBankAccounts && showSubmitButton && !isBankAccountSelected" class="submit-button">
                                        <a class="btn btn-next" (click)="onSubmitBankAccount()">Submit</a>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </form>

                </div>
            </div>
        </div>




    </div>
